import React from 'react';
import FixedView from '../FixedView';
import moment from 'moment';
import Calender from './Calendar';
import { checkTranslation } from '../../utils/useful';

const WeeksName = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MonthsName = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
const YearsName = ['2022', '2021', '2020', '1999', '1998', '1997', '1996'];

export default class WeekCol extends React.Component {
    constructor(props) {
        super(props);
        this.firstView = React.createRef();
        this.firstCurrentNode = React.createRef();
        this.yearCurrentNode = React.createRef();
        this.yearCurrentNode = React.createRef();

        this.state = {
            calender: new Calender(),
            selectedDay: '',
            key: 'TEpyxZL1neC2JBZViuDaJ',
            sectionsPerHour: 2,
            currentTime: null,
            sectionsHeigth: 30,
            timeIndicatorTop: -1,
        };
    }

    componentDidMount() {
        this.setState({ data: this.props.data });
        if (this.props.title) {
            this.setDay(0, this.props.title)

        } else {
            this.setDay(0)
        }
    }

    showMonthList = () => {
        this.firstView.showView();
    };

    showYearList = () => {
        this.yearView.showView();
    };

    selectDay = (year, month, day) => {
        let newDate = moment.utc();
        newDate.set('year', year);
        newDate.set('month', month - 1);
        newDate.set('date', day);
        this.setState({ selectedDay: [newDate.format('YYYY MM DD'), { day, month, year }] }, () => {
            this.changeData();
        });
    };

    changeData = () => {
        let showData = this.state.data;
        let key = this.state.key;
        showData = showData?.filter(
            (cdata) => moment(cdata?.values[key]).format('YYYY MM DD') === this.state.selectedDay[0]
        );
        this.setState({ showData });
    };

    setDay(fromNow, startDate) {


        let now = new Date();
        let hours = []
        let sections = []

        let start = moment(now).startOf('day').add(fromNow, 'days').startOf('day')
        let end = moment(now).startOf('day').add(fromNow, 'days').endOf('day')

        if (startDate) {
            start = moment(startDate).add(fromNow, 'days').startOf('day')
            end = moment(startDate).add(fromNow, 'days').endOf('day')
        }



        // console.log(moment(now).add(fromNow, 'month').daysInMonth())

        let minutes = 60 / this.state.sectionsPerHour

        for (let i = 0; i < 24; i++) {
            let dName = i + ' am'
            let tempName = i

            if (i > 11) {
                dName = i - 12 + ' pm'
                tempName = i - 12
            }
            if (i == 0) {
                dName = '12 am'
                tempName = 12
            }
            if (i == 12) {
                dName = '12 pm'
                tempName = 12
            }
            let startOfHour = moment(start).add(i, 'hours').valueOf()
            let endOfHour = moment(start).add(i + 1, 'hours').valueOf() - 1


            for (let j = 0; j < this.state.sectionsPerHour; j++) {

                let startOfSection = moment(startOfHour).add(j * minutes, 'minutes').valueOf()
                let endOfSection = moment(startOfHour).add((j + 1) * minutes, 'minutes').valueOf() - 1

                let sName = this.makeTwoDigits(tempName) + ':' + this.makeTwoDigits(String(minutes * j)) + (i > 11 ? ' pm' : ' am')


                sections.push({ hour: i, sName, dName: j == 0 ? dName : null, start: startOfSection, end: endOfSection, hStart: startOfHour, hEnd: endOfHour, data: [] })

            }

            hours.push({ hour: i, dName, start: startOfHour, end: endOfHour })


        }

        // console.log(hours)
        // console.log(sections)

        // let newDate = [Number(moment(start).format('YYYY')), moment(start).format('M') - 1, 1]

        this.setState({ hours, sections, day: { start, end } }, () => {
            // this.arrangeData()
            // this.getCurrentTime()

        })

    }


    makeTwoDigits(number) {
        let final = number
        if (number && number.length < 2) {
            final = "0" + String(number)
        }
        return final
    }

    render() {
        const { calender } = this.state;
        const week = calender.getWeek();
        const rToday = calender.getToday();
        let cToday = {
            year: calender.toMoment().format('YYYY'),
            month: calender.toMoment().format('MM'),
            day: 0,
        }; // calenderToday
        

        return (
            <div className='h-100' style={{ direction: 'ltr' }}>
                <div className='h-100' style={{ background: '#fff' }}>
                    <div style={{ margin: '0 2%' }} className='d-flex justify-content-between pb-2 pt-3 px-3'>
                        <div className='d-flex align-content-center ' style={{zIndex:4}}>
                            <p
                                className='text-center font-size-15'
                                onClick={() => this.showMonthList()}
                                ref={(el) => (this.firstCurrentNode = el)}
                                style={{ minWidth: 85 }}
                            >
                                {calender.toMoment().format('MMMM')}
                            </p>
                            <p
                                className='text-center px-2 font-size-15'
                                onClick={() => this.showYearList()}
                                ref={(el) => (this.yearCurrentNode = el)}
                                style={{}}
                            >
                                {calender.toMoment().format('YYYY')}
                            </p>
                            <button className='mt-1' onClick={() => { calender.goToPrev('month'); this.setState({ calender }) }}>
                                <img src='/assets/icons/chevron.backward-gray.svg' width={17} alt='back' className=' btn-hover1' style={{ cursor: 'pointer' }} />
                                <img style={{ cursor: 'pointer' }} width={18} className='' src='/assets/icons/dot.png' />
                            </button>
                            <button className='mt-1' onClick={() => { calender.goToNext('month'); this.setState({ calender }) }}>
                                <img className=' btn-hover1' src='/assets/icons/chevron.forward-gray.svg' alt='next' width={17} style={{ cursor: 'pointer' }} />
                            </button>
                        </div>
                        <div>
                            <button className='mr-2' onClick={() => { calender.goToPrev('week'); this.setState({ calender }) }}>
                                <img src='/assets/icons/arrowtriangle.left.circle.fill.svg' alt='back' style={{ opacity: '50%' }} />
                            </button>
                            <button onClick={() => { calender.goToNext('week'); this.setState({ calender }) }}>
                                <img src='/assets/icons/arrowtriangle.right.circle.fill.svg' alt='next' style={{ opacity: '50%' }} />
                            </button>
                        </div>
                    </div>
                    <FixedView ref={(el) => (this.firstView = el)} nodeRef={this.firstCurrentNode} showFocus={false} topOffset={2} xOffset={20} zIndex={10}>
                        <div className='month-list'>
                            {MonthsName.map((month, index) => {
                                return (
                                    <div onClick={() => { calender.setMonth(index + 1); this.setState({ calender }) }} className='month-name'>
                                        {checkTranslation(month)}
                                    </div>
                                );
                            })}
                        </div>
                    </FixedView>
                    <FixedView ref={(el) => (this.yearView = el)} nodeRef={this.yearCurrentNode} showFocus={false} topOffset={20} xOffset={20} zIndex={10}>
                        <div className='year-list'>
                            {YearsName?.map((year, index) => {
                                return (
                                    <div onClick={() => { calender.setYear(year); this.setState({ calender }) }} className='year-name'>
                                        {checkTranslation(year)}
                                    </div>
                                );
                            })}
                        </div>
                    </FixedView>
                    {/* <div className='p-3 br-10 0 m-2' style={{ padding: '0 5%', background: '#edede9' }}>
                        <div className='d-flex' style={{ justifyContent: 'space-between' }}>
                            <button onClick={() => { calender.goToPrev('week'); this.setState({ calender }) }}>
                                <img src='/assets/icons/arrowtriangle.left.circle.fill.svg' alt='back' style={{ opacity: '50%' }} />
                            </button>
                            {week.map((day, index) => {
                                cToday.day = day;
                                let selectedDay = this.state.selectedDay;

                                const isSelected =
                                    selectedDay ?
                                        (cToday.year === selectedDay[1].year) && (cToday.day === selectedDay[1].day) && (cToday.month === selectedDay[1].month) :
                                        (cToday.year === rToday.year) && (cToday.day === rToday.day) && (cToday.month === rToday.month);

                                return (
                                    <div
                                        onDragOver={this.handleDragOver}
                                        onDrop={(event) => this.handleDrop(event, cToday, day)}
                                        onClick={() => this.selectDay(cToday.year, cToday.month, day)}
                                        className=' mx-1'
                                        style={{ alignItems: 'center', background: isSelected ? '#226efc' : 'transparent', borderRadius: 5, width: '14%' }}
                                    >
                                        <div style={{ padding: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <div>
                                                <p style={{ fontSize: 15, color: isSelected ? '#fff' : '#000' }}>{checkTranslation(WeeksName[index])}</p>
                                            </div>
                                            <div>
                                                <p style={{ color: isSelected ? '#fff' : '#000' }}>{checkTranslation(day)}</p>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                            <button onClick={() => { calender.goToNext('week'); this.setState({ calender }) }}>
                                <img src='/assets/icons/arrowtriangle.right.circle.fill.svg' alt='next' style={{ opacity: '50%' }} />
                            </button>
                        </div>
                    </div> */}
                </div>
                <div className='d-flex p-1 h-100'>
                    <div className='pt-5 ' style={{ backgroundColor: 'white', width: '50px' }}>
                        {this.state.sections?.map((prop, index) => {
                            let isCurrentHour = false
                            if (this.state.timeIndicatorTop >= 0 && prop.dName && this.state.currentTime >= prop.hStart && this.state.currentTime <= prop.hEnd) {
                                isCurrentHour = true
                            }
                            return (
                                <div key={index} className="w-100 " style={{ padding: '2px 6px', height: this.state.sectionsHeigth }}>
                                    {prop.dName && (
                                        <p className="font-size-10 text-end" style={{ marginTop: -10, color: isCurrentHour ? '#ee5050' : '#666', }}>{checkTranslation(prop.dName)}</p>
                                    )}
                                </div>
                            )
                        })}
                    </div>
                    {week.map((day, index) => {
                        cToday.day = day;
                        const isSelected = this.state.selectedDay ? (cToday.year === this.state.selectedDay[1].year) && (cToday.day === this.state.selectedDay[1].day) && (cToday.month === this.state.selectedDay[1].month) : (cToday.year === rToday.year) && (cToday.day === rToday.day) && (cToday.month === rToday.month);
                        let tasksForDay = this.state.data?.filter((cdata) => moment(cdata?.values[this.state.key]).format('YYYY MM DD') === moment(`${cToday.year} ${cToday.month} ${day}`, 'YYYY MM DD').format('YYYY MM DD'));
                        return (
                            <div className="h-100 flex-grow-1 mx-1 pr-3 p-1"
                                onDragOver={this.handleDragOver}
                                onDrop={(event) => this.handleDrop(event, cToday, day)}
                                // onClick={() => this.selectDay(cToday.year, cToday.month, day)}
                                style={{ width: "14%", borderRight: '1px solid #b5b5b5', }}>
                                <div className='flexcb' style={{ background: isSelected ? '#226efc' : '#fff', borderRadius: 5, padding: 5 }}>
                                    <p style={{ color: isSelected ? '#fff' : '#000' }}>{checkTranslation(WeeksName[index])}</p>
                                    <p style={{ color: isSelected ? '#fff' : '#000' }}>{checkTranslation(day)}</p>
                                </div>
                                <div className='pb-5 h-100' style={{minHeight:"154vh"}}>
                                    {tasksForDay?.map((prop, index) => {
                                        let keyText = 'a1b2cda0-3b22-4081-a1ac-4428470f42d2';
                                        return (
                                            <div
                                                draggable
                                                id={prop._id}
                                                key={prop._id}
                                                onDragStart={(event) => this.handleDragStart(event, prop)}
                                                className='p-2 m-1'
                                                style={{ background: '#eaeaeaa9', borderRadius: '8px', fontSize: "0.6rem" }}
                                            >
                                                <p> {prop?.values[keyText]}</p>
                                                <p> {moment(prop?.values[this.state.key]).format('YYYY MM DD')}</p>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div style={{minHeight:"20vh", background:"#fff"}}></div>
            </div>
        );
    }
    handleDragStart = (event, prop) => {
        this.setState({ draggedItem: prop });
        let i = document.getElementById(prop._id);
        event.dataTransfer.setDragImage(i, 0, 0);
    };
    handleDragOver = (event) => {
        event.preventDefault();
    };

    handleDrop = (event, cToday, day) => {
        let str = `${cToday.year} ${cToday.month} ${day}`;
        const momentDate = moment(str, 'YYYY MM DD');
        const timestamp = momentDate.valueOf();
        let data = this.state.data;
        let key = this.state.key;
        data.forEach((item) => {
            if (item._id == this.state.draggedItem._id) {
                item.values[key] = timestamp;
            }
        });
        let item = this.state.draggedItem;
        item.values[key] = timestamp;
        this.setState({ data }, () => {
            this.changeData();
        });
        this.props.submitForm(item, true);

        this.setState({
            draggedItem: null,
        });
    };
}
